export default __webpack_public_path__ + "static/media/partner2.c33e4a6d.png";